import { Box, Tabs, useTheme, Tab } from '@mui/material'
import React, { useEffect, useState } from 'react'
import PrivateRC from '../../components/PrivateRC'
import RelatorioLeitura from './gestao'
// import filter from './filters'
import { BaseAutoComplete, BaseDatePicker } from '../../components/shared'
import BaseFloatFilter from '../../components/BaseFloatFilter'
import Dater from '../../services/DateFormat'
import { Bibliotecas, FormatosExemplares } from '../../services/http'
import RelatorioAcervo from './Acervo'
import dayjs from 'dayjs'
import getLeitor from '../../services/http/user/getLeitor'
import Users from '../../services/http/user/Users'
import { toast } from 'react-toastify'

const RelatoriosAbas = () => {
  const [tab, setTab] = useState(0)
  const theme = useTheme()

  const [query, setQuery] = useState({})
  const [libName, setLibName] = useState('')
  const [bibliotecas, setBibliotecas] = useState([])
  const [leitor, setLeitor] = useState('')
  const [user, setUser] = useState([])
  const [formatos, setFormatos] = useState([])
  // const meses = Dater().meses

  const init = async () => {
    const leitores = await getLeitor()
    setLeitor(leitores[0])

    getFormatos()

    setLibName(leitores[0]?.biblioteca?.apelido)
    setQuery({
      biblioteca: leitores[0]?.biblioteca_id,
      ano: new Date().getFullYear()
    })
  }

  const getBibliotecas = async () => {
    const { data } = await Bibliotecas().show({ per_page: -1 })
    setBibliotecas(data.data)
  }

  const getFormatos = async () => {
    try {
      const { data } = await FormatosExemplares().show()

      setFormatos(data.data)
    } catch (e) {
      toast.error('Falha ao obter os formatos de obras')
      console.error(e)
    }
  }

  const getUsers = async () => {
    const { data } = await Users().show({ per_page: -1, ativo: true })
    setUser(data.data)
  }

  useEffect(() => {
    getBibliotecas()
    getUsers()

    init()
  }, [])

  const [currentDate, setCurrentDate] = useState(dayjs())

  return (
    <Box sx={{ mt: 2 }}>
      <PrivateRC roles="bibliotecario">
        <Tabs
          value={tab}
          onChange={(event, newValue) => {
            setTab(newValue)
          }}
          TabIndicatorProps={{
            style: {
              backgroundColor: theme.palette.leitura.main
            }
          }}
        >
          <Tab onClick={() => setTab(0)} label="Relatórios de Leitura" />
          {/* <Tab onClick={() => setTab(1)} label="Relatórios de Empréstimo" /> */}
          <Tab onClick={() => setTab(1)} label="Relatórios de Acervo" />
          {/* <Tab onClick={() => setTab(1)} label="Relatórios de Acervo" /> */}
        </Tabs>
      </PrivateRC>
      <div
        style={{
          marginTop: '1rem',
          display: 'flex',
          justifyContent: 'space-evenly'
        }}
      >
        <PrivateRC roles={'bibliotecario'}>
          <BaseFloatFilter
            // filter={filter}
            onChange={value => {
              setQuery(Object.assign({ ...query }, { user_id: value.user_id }))
            }}
            components={
              <>
                <BaseAutoComplete
                  sx={{ marginBottom: '1rem' }}
                  listLabel="apelido"
                  list={bibliotecas}
                  onChange={value => {
                    setLibName(value.apelido)
                    setQuery({ ...query, biblioteca: value.id })
                  }}
                  inputProps={{
                    label: 'Biblioteca',
                    color: 'default'
                  }}
                />
                {tab === 0 && (
                  <BaseAutoComplete
                    sx={{ marginBottom: '1rem' }}
                    listLabel="name"
                    list={user}
                    onChange={value => {
                      setLibName(value.apelido)
                      setQuery({ ...query, user_id: value.id })
                    }}
                    inputProps={{
                      label: 'Leitor',
                      color: 'default'
                    }}
                  />
                )}
                {tab === 1 && (
                  <>
                    {/* <BaseAutoComplete
                      sx={{ marginBottom: '1rem' }}
                      list={meses}
                      listLabel={'nome'}
                      inputProps={{
                        label: 'Mês'
                      }}
                      onChange={event => {
                        if (!event.mes) resetMeses()
                        setQuery({ ...query, mes_id: event?.mes })
                      }}
                    /> */}

                    <BaseAutoComplete
                      sx={{ marginBottom: '1rem' }}
                      list={formatos}
                      listLabel={'descricao'}
                      inputProps={{
                        label: 'Formato'
                      }}
                      onChange={event => {
                        setQuery({ ...query, formato: event?.id })
                      }}
                    />
                  </>
                )}
                {tab === 0 && (
                  <BaseDatePicker
                    minDate={
                      parseInt(Dater().formatar(new Date(), 'yyyy')) -
                      1 +
                      '-01-01'
                    }
                    maxDate={
                      parseInt(Dater().formatar(new Date(), 'yyyy')) + '-12-31'
                    }
                    value={currentDate}
                    onChange={date => {
                      setQuery({ ...query, ano: date.$y })
                      setCurrentDate(date)
                    }}
                    label="Ano"
                    inputFormat="YYYY"
                    openTo="year"
                    views={['year']}
                    onClear={() => {
                      setQuery({ ...query, ano: null })
                    }}
                    clearable={true}
                  />
                )}
              </>
            }
          />
        </PrivateRC>
      </div>
      {tab === 0 && (
        <PrivateRC roles="leitor">
          <RelatorioLeitura filter={query} leitor={leitor} libName={libName} />
        </PrivateRC>
      )}
      {/* {tab === 1 && (
        <PrivateRC roles="bibliotecario">
          <RelatorioEmprestimo filter={query} libName={libName} />
        </PrivateRC>
      )} */}
      {tab === 1 && (
        <PrivateRC roles="bibliotecario">
          <RelatorioAcervo filter={query} libName={libName} />
        </PrivateRC>
      )}
    </Box>
  )
}

export default RelatoriosAbas
